export const transactionType = [
  { id: 1, label: 'Cheque/DDNo' },
  { id: 2, label: 'Neft Rtgs/imps' },
  { id: 3, label: 'Cash/Deposit' },
  { id: 4, label: 'Others' },
];
